import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

function SubjectCombination() {
    return (
        <>
            <Header />

            {/*  */}
            <section style={{ animation: 'fadeIn 1s ease-in-out' }}>
                <div className='container-fluid' style={{ background: '#002147' }}>
                    <div className='row'>
                        <div className='col-12'>
                            <h4 className="text-center text-uppercase py-3" style={{ color: 'white', fontWeight: 'bold' }}>Subject Combination Class XI</h4>
                        </div>
                    </div>
                </div>
                <div className='container subject-combination mx-auto'>
                    <div className='row'>
                        <div className="col-12 pt-3 text-center">
                            <div>
                                <h3>Session 2026 - 2027
                                </h3>
                            </div>
                        </div>
                        <h4 className='text-center text-uppercase'>Group - I</h4>
                        <div className="col-lg-10 text-center" style={{ margin: 'auto' }}>
                            <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '80%', margin: 'auto', fontSize: '15px' }}>
                                <thead>
                                    <tr>
                                        <th className='text-uppercase'>S. No.</th>
                                        <th className='text-uppercase'>Subjects</th>
                                        <th className='text-uppercase'>Subject Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td align='left'>English</td>
                                        <td>301</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td align='left'>Physics</td>
                                        <td>042</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td align='left'>Chemistry</td>
                                        <td>043</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td align='left'>Mathematics</td>
                                        <td>041</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td align='left'>Computer Science / Data Science</td>
                                        <td>083 / 844</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className='text-center text-uppercase'>Group - II</h4>
                        <div className="col-lg-10 text-center" style={{ margin: 'auto' }}>
                            <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '80%', margin: 'auto', fontSize: '15px' }}>
                                <thead>
                                    <tr>
                                        <th className='text-uppercase'>S. No.</th>
                                        <th className='text-uppercase'>Subjects</th>
                                        <th className='text-uppercase'>Subject Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td align='left'>English</td>
                                        <td>301</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td align='left'>Physics</td>
                                        <td>042</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td align='left'>Chemistry</td>
                                        <td>043</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td align='left'>Mathematics</td>
                                        <td>041</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td align='left'>Economics / Physical Education</td>
                                        <td>030 / 048</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className='text-center text-uppercase'>Group - III</h4>
                        <div className="col-lg-10 text-center" style={{ margin: 'auto' }}>
                            <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '80%', margin: 'auto', fontSize: '15px' }}>
                                <thead>
                                    <tr>
                                        <th className='text-uppercase'>S. No.</th>
                                        <th className='text-uppercase'>Subjects</th>
                                        <th className='text-uppercase'>Subject Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td align='left'>English</td>
                                        <td>301</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td align='left'>Physics</td>
                                        <td>042</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td align='left'>Chemistry</td>
                                        <td>043</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td align='left'>Biology</td>
                                        <td>044</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td align='left'>Physical Education/ Food Nutrition & Dietetics</td>
                                        <td>048 / 834</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className='text-center text-uppercase'>Group - IV</h4>
                        <div className="col-lg-10 text-center" style={{ margin: 'auto' }}>
                            <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '80%', margin: 'auto', fontSize: '15px' }}>
                                <thead>
                                    <tr>
                                        <th className='text-uppercase'>S. No.</th>
                                        <th className='text-uppercase'>Subjects</th>
                                        <th className='text-uppercase'>Subject Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td align='left'>English</td>
                                        <td>301</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td align='left'>Business Studies</td>
                                        <td>054</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td align='left'>Accountancy</td>
                                        <td>055</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td align='left'>Mathematics</td>
                                        <td>041</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td align='left'>Economics / Marketing</td>
                                        <td>030 / 812 </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className='text-center text-uppercase'>Group - V</h4>
                        <div className="col-lg-10 text-center" style={{ margin: 'auto' }}>
                            <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '80%', margin: 'auto', fontSize: '15px' }}>
                                <thead>
                                    <tr>
                                        <th className='text-uppercase'>S. No.</th>
                                        <th className='text-uppercase'>Subjects</th>
                                        <th className='text-uppercase'>Subject Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td align='left'>English</td>
                                        <td>301</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td align='left'>Business Studies</td>
                                        <td>054</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td align='left'>Accountancy</td>
                                        <td>055</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td align='left'>Informatics Practices / Data Science</td>
                                        <td>065 / 844</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td align='left'>Economics / Marketing</td>
                                        <td>030 / 812</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className='text-center text-uppercase'>Group - VI</h4>
                        <div className="col-lg-10 text-center" style={{ margin: 'auto' }}>
                            <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '80%', margin: 'auto', fontSize: '15px' }}>
                                <thead>
                                    <tr>
                                        <th className='text-uppercase'>S. No.</th>
                                        <th className='text-uppercase'>Subjects</th>
                                        <th className='text-uppercase'>Subject Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td align='left'>English</td>
                                        <td>301</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td align='left'>History</td>
                                        <td>027</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td align='left'>Geography</td>
                                        <td>029</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td align='left'>Political Science</td>
                                        <td>028</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td align='left'>Economics / Painting / Data Science</td>
                                        <td>030 / 049 / 844</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className='text-center text-uppercase'>Group - VII</h4>
                        <div className="col-lg-10 text-center" style={{ margin: 'auto', paddingBottom:'50px' }}>
                            <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '80%', margin: 'auto', fontSize: '15px' }}>
                                <thead>
                                    <tr>
                                        <th className='text-uppercase'>S. No.</th>
                                        <th className='text-uppercase'>Subjects</th>
                                        <th className='text-uppercase'>Subject Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td align='left'>English</td>
                                        <td>301</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td align='left'>History</td>
                                        <td>027</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td align='left'>Geography</td>
                                        <td>029</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td align='left'>Physical Education</td>
                                        <td>048</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td align='left'>Economics / Painting</td>
                                        <td>030 / 049</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>

            <Footer/>
        </>
    )
}

export default SubjectCombination
